// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetOrderBook (params?: {}): Promise<Dict>;
    publicGetTicker (params?: {}): Promise<Dict>;
    publicGetTickerAll (params?: {}): Promise<Dict>;
    publicGetProducts (params?: {}): Promise<Dict>;
    publicGetTransactions (params?: {}): Promise<Dict>;
    publicGetTradingPairs (params?: {}): Promise<Dict>;
    publicGetSystemTime (params?: {}): Promise<Dict>;
    privatePostCurrencies (params?: {}): Promise<Dict>;
    privatePostBalances (params?: {}): Promise<Dict>;
    privatePostBitcoinCashWithdrawal (params?: {}): Promise<Dict>;
    privatePostBitcoinCashDepositAddresses (params?: {}): Promise<Dict>;
    privatePostBitcoinDepositAddresses (params?: {}): Promise<Dict>;
    privatePostBitcoinWithdrawal (params?: {}): Promise<Dict>;
    privatePostBitcoinWithdrawalFees (params?: {}): Promise<Dict>;
    privatePostBuyInstant (params?: {}): Promise<Dict>;
    privatePostBuyLimit (params?: {}): Promise<Dict>;
    privatePostCancelOrder (params?: {}): Promise<Dict>;
    privatePostCancelOrderWithInfo (params?: {}): Promise<Dict>;
    privatePostCreateVoucher (params?: {}): Promise<Dict>;
    privatePostDashDepositAddresses (params?: {}): Promise<Dict>;
    privatePostDashWithdrawal (params?: {}): Promise<Dict>;
    privatePostEthereumWithdrawal (params?: {}): Promise<Dict>;
    privatePostEthereumDepositAddresses (params?: {}): Promise<Dict>;
    privatePostLitecoinWithdrawal (params?: {}): Promise<Dict>;
    privatePostLitecoinDepositAddresses (params?: {}): Promise<Dict>;
    privatePostOpenOrders (params?: {}): Promise<Dict>;
    privatePostOrder (params?: {}): Promise<Dict>;
    privatePostOrderHistory (params?: {}): Promise<Dict>;
    privatePostOrderById (params?: {}): Promise<Dict>;
    privatePostPusherAuth (params?: {}): Promise<Dict>;
    privatePostRedeemVoucher (params?: {}): Promise<Dict>;
    privatePostReplaceByBuyLimit (params?: {}): Promise<Dict>;
    privatePostReplaceByBuyInstant (params?: {}): Promise<Dict>;
    privatePostReplaceBySellLimit (params?: {}): Promise<Dict>;
    privatePostReplaceBySellInstant (params?: {}): Promise<Dict>;
    privatePostRippleDepositAddresses (params?: {}): Promise<Dict>;
    privatePostRippleWithdrawal (params?: {}): Promise<Dict>;
    privatePostSellInstant (params?: {}): Promise<Dict>;
    privatePostSellLimit (params?: {}): Promise<Dict>;
    privatePostTransactionHistory (params?: {}): Promise<Dict>;
    privatePostTraderFees (params?: {}): Promise<Dict>;
    privatePostTradeHistory (params?: {}): Promise<Dict>;
    privatePostTransfer (params?: {}): Promise<Dict>;
    privatePostTransferHistory (params?: {}): Promise<Dict>;
    privatePostUnconfirmedBitcoinDeposits (params?: {}): Promise<Dict>;
    privatePostUnconfirmedBitcoinCashDeposits (params?: {}): Promise<Dict>;
    privatePostUnconfirmedDashDeposits (params?: {}): Promise<Dict>;
    privatePostUnconfirmedEthereumDeposits (params?: {}): Promise<Dict>;
    privatePostUnconfirmedLitecoinDeposits (params?: {}): Promise<Dict>;
    privatePostUnconfirmedRippleDeposits (params?: {}): Promise<Dict>;
    privatePostCancelAllOpenOrders (params?: {}): Promise<Dict>;
    privatePostWithdrawVirtualCurrency (params?: {}): Promise<Dict>;
    privatePostVirtualCurrencyDepositAddresses (params?: {}): Promise<Dict>;
    privatePostUnconfirmedVirtualCurrencyDeposits (params?: {}): Promise<Dict>;
    privatePostAdaWithdrawal (params?: {}): Promise<Dict>;
    privatePostAdaDepositAddresses (params?: {}): Promise<Dict>;
    privatePostUnconfirmedAdaDeposits (params?: {}): Promise<Dict>;
    privatePostDaiWithdrawal (params?: {}): Promise<Dict>;
    privatePostDaiDepositAddresses (params?: {}): Promise<Dict>;
    privatePostUnconfirmedDaiDeposits (params?: {}): Promise<Dict>;
    privatePostSolWithdrawal (params?: {}): Promise<Dict>;
    privatePostSolDepositAddresses (params?: {}): Promise<Dict>;
    privatePostUnconfirmedSolDeposits (params?: {}): Promise<Dict>;
    privatePostBankWireWithdrawal (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
